import { WellKnownProperties } from '../models/erp/properties';
import { extractPropertiesFromProductNumber } from './productNumber';

type ChargingOptionProperties = Pick<
    WellKnownProperties,
    'chargingOption_type' | 'chargingOption_connector' | 'chargingOption_capacity'
> & { productName: string };

const PRODUCT_CODE_TO_CHARGING_OPTION_PROPERTIES = {
    '206': {
        productName: 'Mobile Charging Station EASY Light (Old version)',
        chargingOption_type: 'mobileChargingStation',
        chargingOption_connector: 'plugLight',
        chargingOption_capacity: 10,
    },
    '207': {
        productName: 'Mobile Charging Station ES Premium',
        chargingOption_type: 'mobileChargingStation',
        chargingOption_connector: 'plugPremium',
        chargingOption_capacity: 9,
    },
    '208': {
        productName: 'Mobile Charging Station Hybrid Premium & Light',
        chargingOption_type: 'mobileChargingStation',
        chargingOption_connector: 'plugsLightPremium',
        chargingOption_capacity: 10,
    },
    '211': {
        productName: 'Mobile Charging Station EASY Light (wide version)',
        chargingOption_type: 'mobileChargingStation',
        chargingOption_connector: 'plugLight',
        chargingOption_capacity: 10,
    },
} as const satisfies Record<string, ChargingOptionProperties>;

export function getChargingOptionPropertiesByProductCode(productCode: string): ChargingOptionProperties | null {
    if (productCode in PRODUCT_CODE_TO_CHARGING_OPTION_PROPERTIES) {
        return PRODUCT_CODE_TO_CHARGING_OPTION_PROPERTIES[productCode as keyof typeof PRODUCT_CODE_TO_CHARGING_OPTION_PROPERTIES];
    }

    return null;
}

export function getChargingOptionPropertiesByProductNumber(productNumber: string): ChargingOptionProperties | null {
    const numberProperties = extractPropertiesFromProductNumber(productNumber);

    if (numberProperties === null) {
        return null;
    }

    return getChargingOptionPropertiesByProductCode(numberProperties.productCode);
}
